export function PhoneMask(value: string | undefined): string {
  if (!value) return "";
  
  const cleanedValue = cleanInputValue(value);
  if (!cleanedValue) return "";
  
  return cleanedValue
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(\d{4})-(\d)(\d{4})/, "$1$2-$3")
    .replace(/(-\d{4})\d+?$/, "$1");
}

export function CpfMask(value: string | undefined): string {
  if (!value) return "";
  
  const cleanedValue = cleanInputValue(value);
  if (!cleanedValue) return "";
  
  return cleanedValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
}

export function dateMask(value: string | undefined): string {
  if (!value) return "";
  
  const cleanedValue = cleanInputValue(value);
  if (!cleanedValue) return "";
  
  return cleanedValue
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{4})\d+?$/, "$1");
}

export function formatCreditCardNumber(value: string | undefined): string {
  if (!value) return "";
  
  const cleanedValue = cleanInputValue(value);
  if (!cleanedValue) return "";
  
  const chunks = cleanedValue.match(/.{1,4}/g);
  return chunks ? chunks.join(" ") : cleanedValue;
}

export function FormatMoneyDynamic(v: any) {
  if (typeof v !== "string") {
    v = String(v);
  }
  v = v.replace(".", "").replace(",", "").replace(/\D/g, "");

  const options = { minimumFractionDigits: 2 };
  const result = new Intl.NumberFormat("pt-BR", options).format(
    parseFloat(v) / 100
  );

  return "R$ " + result;
}

export function formatCEP(value: string | undefined): string {
  if (!value) return "";
  
  const cleanedValue = cleanInputValue(value);
  if (!cleanedValue) return "";
  
  return cleanedValue.replace(/^(\d{5})(\d{3})$/, "$1-$2");
}

export function RgMask(value: string | undefined): string {
  if (!value) return "";
  
  const cleanedValue = cleanInputValue(value);
  if (!cleanedValue) return "";
  
  return cleanedValue
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function cleanInputValue(value: string): string {
  return value?.replace(/\D/g, "") || "";
}

export function cleanCEP(value: string): string {
  const cleaned = cleanInputValue(value);
  return cleaned.length >= 8 ? cleaned.substring(0, 8) : cleaned;
}

export function formatInputValue(value: string, mask: (value: string) => string): string {
  const cleanedValue = cleanInputValue(value);
  return cleanedValue ? mask(cleanedValue) : "";
}

export function CnpjMask(value: string | undefined): string {
  if (!value) return "";
  
  const cleanedValue = cleanInputValue(value);
  if (!cleanedValue) return "";
  
  return cleanedValue
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
}

export function readingDateMask(value: string | undefined): string {
  if (!value) return "";
  
  const cleanedValue = cleanInputValue(value);
  if (!cleanedValue) return "";
  
  // Remove any value greater than 31
  const numericValue = parseInt(cleanedValue, 10);
  if (numericValue > 31) {
    return "31";
  }
  
  return cleanedValue;
}
